import { render, staticRenderFns } from "./aboutoursmessage.vue?vue&type=template&id=22626694&scoped=true&"
import script from "./aboutoursmessage.vue?vue&type=script&lang=js&"
export * from "./aboutoursmessage.vue?vue&type=script&lang=js&"
import style0 from "./aboutoursmessage.vue?vue&type=style&index=0&id=22626694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22626694",
  null
  
)

export default component.exports